import type { Page } from "@cafegestor/shared";
import type { ReactNode } from "react";

/** Um registro encontrado, no formato que o lookup mostra. */
export type LookupRow = {
  id: string;
  code: string;
  name: string;
  /** segunda linha da sugestão (documento e cidade, unidade e disponível...) */
  secondary?: string;
  inactive: boolean;
};

export type LookupQuery = {
  q: string;
  limit: number;
  offset: number;
  /** inclui inativos (filtro da lupa) */
  includeInactive: boolean;
  /** filtros extras da lupa, por nome (ex.: uf) */
  filters: Record<string, string>;
};

/** Um filtro da lupa: lista de opções fechadas. */
export type LookupFilter = { name: string; label: string; options: [string, string][] };

/**
 * Como pesquisar um tipo de cadastro: rota, colunas da lupa e textos. Os dados vêm SEMPRE da
 * API (empresa ativa e RLS); o lookup não guarda nada entre empresas.
 */
export type LookupSource<T> = {
  /** chave do cache (inclui o que muda a resposta, ex.: depósito da venda) */
  key: readonly unknown[];
  /** "cliente", "produto"... (mensagens) */
  noun: string;
  placeholder: string;
  /** texto quando nada é encontrado */
  empty: string;
  search: (query: LookupQuery, signal: AbortSignal) => Promise<Page<T>>;
  toRow: (item: T) => LookupRow;
  columns: { header: string; cell: (item: T) => ReactNode; className?: string }[];
  filters?: LookupFilter[];
};

/** Texto do registro escolhido no campo: "CAFE500 — Café Grão 500g". */
export const lookupLabel = (r: Pick<LookupRow, "code" | "name">) => `${r.code} — ${r.name}`;
